import { IStore } from '../../reducers/index'

const projectorModeSelector = (state: IStore) => state.app.projectorMode

export default projectorModeSelector
